import React, { useEffect, useState } from "react";
import './ConfiguracionPago.css';
import { obtenerEstadoSuscripcion, crearCheckout } from "../services/pagos"; // Importamos las funciones de pagos.js

const ConfiguracionPago = () => {
  const [estado, setEstado] = useState("");
  const [diasRestantes, setDiasRestantes] = useState(null);
  const [linkPortal, setLinkPortal] = useState("");
  const [planSeleccionado, setPlanSeleccionado] = useState("mensual");
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchEstado = async () => {
      setCargando(true);
      try {
        // Usamos la función de pagos.js en lugar de axios directamente
        const data = await obtenerEstadoSuscripcion();
        
        setEstado(data.status);
        setLinkPortal(data.portal_url);
        
        // Manejar información de días restantes si está en trial
        if (data.dias_restantes !== undefined) {
          setDiasRestantes(data.dias_restantes);
        }
        
        setCargando(false);
      } catch (error) {
        console.error("Error obteniendo estado suscripción", error);
        setError("No pudimos cargar tu información de suscripción. Intenta más tarde.");
        setCargando(false);
      }
    };

    fetchEstado();
  }, []);

  const handleCheckout = async () => {
    setCargando(true);
    
    try {
      // Usamos la función de pagos.js en lugar de axios directamente
      const data = await crearCheckout(planSeleccionado);
      window.location.href = data.url;
    } catch (error) {
      console.error("Error al crear checkout:", error);
      setError("Hubo un problema al procesar tu solicitud. Intenta más tarde.");
      setCargando(false);
    }
  };

  // El resto del componente se mantiene igual
  const renderEstadoMensaje = () => {
    switch (estado) {
      case "active":
        return <p className="estado-activo">Tu suscripción está activa y funcionando correctamente.</p>;
      case "trialing":
        return (
          <div className="estado-trial">
            <p>Estás en periodo de prueba.</p>
            {diasRestantes !== null && (
              <p><strong>Te quedan {diasRestantes} días</strong> de tu periodo de prueba gratuito.</p>
            )}
          </div>
        );
      case "past_due":
        return <p className="estado-warning">Tu pago está pendiente. Por favor, actualiza tu método de pago para evitar perder acceso.</p>;
      case "canceled":
        return <p className="estado-cancelado">Tu suscripción ha sido cancelada. Contrata un nuevo plan para seguir usando todas las funciones.</p>;
      case "incomplete":
      case "incomplete_expired":
        return <p className="estado-warning">Hubo un problema con tu último pago. Por favor, actualiza tu método de pago.</p>;
      case "sin_suscripcion":
        return <p className="estado-inactivo">No tienes una suscripción activa. Contrata un plan para acceder a todas las funciones.</p>;
      default:
        return <p>Verificando estado de tu suscripción...</p>;
    }
  };

  if (cargando) {
    return (
      <div className="configuracion-pago-container">
        <h1>Cargando información de pago...</h1>
      </div>
    );
  }

  if (error) {
    return (
      <div className="configuracion-pago-container">
        <h1>Configuración de Pago</h1>
        <p className="error-mensaje">{error}</p>
        <button onClick={() => window.location.reload()}>Intentar nuevamente</button>
      </div>
    );
  }

  return (
    <div className="configuracion-pago-container" style={{ maxWidth: 600, margin: "auto", padding: "20px" }}>
      <h1>Configuración de Pago</h1>
      
      {renderEstadoMensaje()}

      {/* Mostrar la selección de plan para usuarios sin suscripción o con suscripción cancelada */}
      {(estado === "sin_suscripcion" || estado === "canceled") && (
        <div className="seleccion-plan" >
          <h2>Elige tu plan</h2>
          
          <div className="planes-container" style={{ display: "flex", gap: "15px", marginBottom: "20px" }}>
            <div 
              className={`plan-card ${planSeleccionado === "mensual" ? "seleccionado" : ""}`}
              onClick={() => setPlanSeleccionado("mensual")}
             
            >
              <h3>Plan Mensual</h3>
              <p className="precio">$169</p>
              <p>MXN/mes IVA incluido</p>
              <p>Acceso completo a todas las funcionalidades</p>
              <p>Facturación mensual</p>
            </div>
            
            <div 
              className={`plan-card ${planSeleccionado === "anual" ? "seleccionado" : ""}`}
              onClick={() => setPlanSeleccionado("anual")}
              
            >
              <h3>Plan Anual</h3>
              <p className="precio">$1690</p>
              <p>MXN/mes IVA incluido</p>
              <p>Ahorra 2 meses al pagar anualmente</p>
              <p>Acceso completo a todas las funcionalidades</p>
            </div>
          </div>

          <button 
            onClick={handleCheckout}
          >
            Contratar Plan
          </button>
        </div>
      )}

      {/* Mostrar el botón del portal para todos los estados excepto sin_suscripcion */}
      {estado !== "sin_suscripcion" && linkPortal && (
        <div className="portal-container" style={{ marginTop: "20px" }}>
           <a href={linkPortal} target="_blank" rel="noreferrer">
            <button className="boton-portal">Gestionar Suscripción</button>
          </a>
          <p>Desde el portal de cliente puedes:</p>
          <ul>
            <li>Ver tu historial de pagos</li>
            <li>Actualizar tu método de pago</li>
            <li>Descargar facturas</li>
          </ul>
         
        </div>
      )}
    </div>
  );
};

export default ConfiguracionPago;